import { css as i, styled as r } from "styled-components";
import { Theme as o } from "../../styles/themes/index.js";
import { skeletonFadeAnimation as p } from "../../styles/animation.js";
import { CaptionHeavy as n } from "../../styles/typography/index.js";
import { Icon as a } from "../Icon/index.js";
const e = i`
  display: inline-flex;
  height: 32px;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px 4px 12px;
  border-radius: 32px 64px 64px 32px;
  ${n}
`, l = r(a)`
  margin-left: 14px;
  font-size: 24px;
  color: rgb(${o.colors.Brand});
`, m = r.span`
  ${e}
  cursor: pointer;
  border: 1px solid rgb(${o.colors.Bravo});
  width: auto;
  background-color: rgb(${o.colors.India});
  color: rgb(${o.colors.Alpha});

  &[aria-selected='true'] {
    background-color: rgb(${o.colors.Juliet});
    color: rgb(${o.colors.Alpha});

    ${l} {
      color: rgb(${o.colors.Alpha});
    }
  }
`, h = r.div`
  height: 22px;
  width: 22px;
  margin-right: 8px;
  border-radius: 4px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`, b = r.span`
  width: ${({ width: t }) => t || "100%"};
  ${e}
  ${p}
`;
export {
  h as ImageWrapper,
  m as TagContainer,
  l as TagIcon,
  b as TagSkeleton,
  e as TagStyle
};
